import React from 'react'
import { View } from 'react-native'
import { useDispatch } from 'react-redux'
import ActionCreators from '../../store/actions'

import styles from './styles'
import { HGText, HGButton } from '../HGUI'
import HGModalFull from './HGModalFull'
import LoginForm, { Credentials } from '../../screens/auth/LoginForm'

type Props = {
  visible: boolean
  onSuccess: () => void
  onAbort: () => void
}

/**
 * This modal is presented when the user has to sign in (again)
 */
const ModalSignIn = (props: Props) => {
  const { onSuccess, onAbort, visible } = props
  const dispatch = useDispatch()

  const _handleFormSubmit = (
    values: Credentials,
    setSubmitting: (value: boolean) => void
  ) => {
    // Validate and login user
    const { username, password } = values
    setSubmitting(true)

    dispatch(ActionCreators.loginUser({ username, password }))
      .then(() => {
        onSuccess()
      })
      .catch((reason) => {
        dispatch(ActionCreators.handleError({ code: reason.code }))
      })
      .then(() => {
        setSubmitting(false)
      })
  }

  return (
    <HGModalFull
      {...props}
      onRequestClose={() => {}}
      style={styles.container}
      visible={visible}
    >
      <View>
        <HGText style={styles.leadHelp}>
          Bitte melden Sie sich für diesen Schritt noch einmal an.
        </HGText>

        <LoginForm onSubmit={_handleFormSubmit} />

        {/* <View style={styles.actionBox}>
          <HGButton
            title="Abbrechen"
            style={styles.actionButton}
            type="inverted"
            onPress={() => {
              onAbort()
            }}
          />
        </View> */}
      </View>
    </HGModalFull>
  )
}

export default ModalSignIn
